module.exports = __webpack_public_path__ + "static/media/Bulk_Manual_Exports_Sample.64dd66d9.csv";